import styled from "styled-components/macro";

export const Container = styled.div`
  display: flex;
  /* width: 1096px; */
  margin: 25px auto 25px auto;
  gap: 25px;
  text-align: center;

  .hero-card {
    position: relative;
    border-radius: 20px;
    padding: 0px;
    width: 322px;
    text-align: center;
    font-family: "GT Super Text";
    background: #fffff5;
    color: #161254;
    height: 405px;
    box-shadow: var(--default-drop-shadow);
    cursor: pointer;

    .image-container {
      height: 237px;
      display: flex;
      justify-content: center;
      position: relative;
      padding: 0;
      margin: 0;

      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .name {
      margin-top: 10px;
      font-size: 26px;
      padding: 0px 20px;
      margin-bottom: 8px;
    }

    .author-name {
      font-size: 14px;
      padding: 0px 20px;
    }

    .description {
      font-size: 18px;
      padding: 0px 20px;
      line-height: 100%;
      margin-bottom: 12px;
    }

    .actions {
      position: absolute;
      bottom: 11.5px;
      right: 11.5px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 15px;

      p {
        margin-top: 12px;
        font-size: 12px;
        font-family: "Inter";
        font-weight: 500;
        opacity: 0.7;
      }

      button {
        font-size: 12px !important;
        padding: 7.5px 11px 7.5px 10px !important;
        font-family: "Inter";
      }
    }
  }

  .other-cards {
    .row-portrait {
      display: flex;
      margin-top: 40px;
      margin-left: 25px;
      gap: 50px;

      .card {
        position: relative;
        border-radius: 20px;
        padding: 0px;
        width: 258px;
        text-align: center;
        font-family: "GT Super Text";
        background: #fffff5;
        color: #161254;
        height: 323px;
        box-shadow: var(--default-drop-shadow);
        cursor: pointer;

        .image-container {
          height: 169px;
          display: flex;
          justify-content: center;
          position: relative;
          padding: 0;
          margin: 0;

          img {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
          }
        }

        .name {
          margin-top: 7px;
          font-size: 20.5px;
          margin-bottom: 7px;
          padding: 0 15px;
        }

        .author-name {
          font-size: 11px;
          padding: 0 15px;

          opacity: 0.7;
        }

        .description {
          font-size: 14px;
          line-height: 100%;
          padding: 0 15px;
          margin-bottom: 8px;
        }

        .actions {
          position: absolute;
          bottom: 12px;
          right: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 15px;

          p {
            margin-top: 12px;
            font-size: 12px;
            font-family: "Inter";
            opacity: 0.7;
            font-weight: 500;
          }

          button {
            padding: 6.5px 10px 6.5px 9px !important;
            font-size: 12px !important;
            font-family: "Inter";
          }
        }
      }
    }

    .row-landscape {
      display: flex;
      justify-content: space-between;
      gap: 25px;
      margin-bottom: 25px;

      &:first-child {
        margin-top: 30px;
      }

      .card {
        position: relative;
        border-radius: 20px;
        width: 310px;
        text-align: center;
        height: calc(160px);
        box-shadow: var(--card-drop-shadow);
        cursor: pointer;
        background: #fffff5;
        color: #161254;
        display: flex;
        gap: 15px;

        .image-container {
          img {
            width: 148px;
            height: 100%;
          }
        }

        .info {
          text-align: left;
          padding-top: 14px;
          padding-right: 14px;

          .name {
            font-family: "GT Super Display";
            font-weight: 600;
            font-size: 17px;
            margin-bottom: 4px;
          }

          .author-name {
            font-family: "GT Super Text";
            font-size: 12px;
            margin-bottom: 8px;
            opacity: 0.7;
          }

          .description {
            font-family: "GT Super Text";
            font-size: 12px;
            line-height: 120%;
          }
        }

        .actions {
          position: absolute;
          bottom: 9px;
          right: 9px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;

          p {
            margin-top: 16px;
            font-size: 12px;
            font-family: "Inter";
            font-weight: 500;
            opacity: 0.7;
          }

          button {
            font-size: 12px !important;
            padding: 4px 10px 4px 9px !important;
            font-family: "Inter";
          }
        }
      }
    }
  }
`;
